import { connect } from 'react-redux';

import { ISidebarProps, Sidebar } from './index';
import { IState } from '../../store';

type TSidebarContainerStateProps = Pick<ISidebarProps, 'village' | 'isCroppedCard'>;

export function mapStateToProps(state: IState): TSidebarContainerStateProps {
  return {
    village: state.villageData.village,
    isCroppedCard: state.isCroppedCard,
  };
}

export const SidebarContainer = connect<TSidebarContainerStateProps>(mapStateToProps)(Sidebar);
